import * as _ from "lodash";
import "select2";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions
} from "../../dashboard/modify_widgets/_BaseModifyWidgetView";


export class ModifyTextWidgetView extends BaseModifyDashboardWidgetView {

    private template = _.template(require('templates/modals/reports/modify_widgets/textwidget/textwidget.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            tagName: "div",
            className: 'widget-type-channels',
            events: {}
        }, options));

        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
        }
    }

    render() {
        this.$el.html(this.template({
            widget: this.options.widget,
            exampleImg: require('../../../../../img/widgettypes/text/textwidgetexample.png')
        }));
        return this;
    }

    preSave() {
        var text = this.$('textarea.add-text').val();
        this.options.widget.setParamValue('TEXT_WIDGET_TEXT', text);

        return true;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifyTextWidgetView.ts